import RecentSearch from "cms/components/dashboard/RecentSearch/RecentSearch";
import SearchBar from "cms/components/dashboard/SearchBar/SearchBar";
import SearchResultComponent from "cms/components/dashboard/SearchResult/SearchResult";
import React, { useState } from "react";
import "./search.css";
import { Col, Row } from "antd";

type SearchTermType = {
  value: string;
  section: string;
  value_id: string;
};

const mockSearchTerms: SearchTermType[] = [
  { value: "AS Biology", section: "structure", value_id: "1" },
  { value: "AS Biology", section: "content", value_id: "2" },
  { value: "AS Biology", section: "department", value_id: "3" },
];

export const SearchTerm: React.FC = () => {
  const [searchResults, setSearchResults] = useState<SearchTermType[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const handleSearch = (term: string) => {
    setSearchTerm(term);
    const results = mockSearchTerms.filter((item) =>
      item.value.toLowerCase().includes(term.toLowerCase())
    );
    setSearchResults(results);
  };

  return (
    <div className="search-term-container">
      <div className="search_results_wrapper">
        <Row gutter={[16, 24]}>
          <Col
            className="gutter-row mb-3"
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
          >
            <div className="current-search-left">
              <SearchBar searchTerms={mockSearchTerms} onSearch={handleSearch} />

              {searchResults.length > 0 && (
                <div className="result-block-title" style={{ marginTop: "20px" }}>
                  <h3>
                    {searchResults.length} results for "{searchTerm}"
                  </h3>
                  <SearchResultComponent results={searchResults} searchTerm={searchTerm} />
                </div>
              )}
            </div>
          </Col>
          <Col
            className="gutter-row mb-3"
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
          >
            <div className="current-search-right">
              <RecentSearch
                onSearchClick={function (searchTerm: string): void {
                  handleSearch(searchTerm);
                }}
              />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};
